import camelCase from 'lodash/camelCase';

/**
 * Adds mutations and actions for deleting.
 *
 * @param {Function} [deleteApi] - a functions that can delete the document of
 * given id. This is an optional field only if passed the corresponding action
 * will be created.
 *
 * @returns {Function} that will take a module and apply the plugin.
 */
export default function(deleteApi) {
  return function(module) {
    const uName = module.name.toUpperCase();

    const DELETE_INIT = `${uName}_DELETE_INIT`;
    const DELETE_DONE = `${uName}_DELETE_DONE`;
    const DELETE_ERROR = `${uName}_DELETE_ERROR`;

    module.addMutationTypes([DELETE_INIT, DELETE_DONE, DELETE_ERROR]);

    const state = {
      deleting: false,
      deleteError: null
    };

    const mutations = {
      [DELETE_INIT](state) {
        state.deleting = true;
      },
      [DELETE_DONE](state) {
        state.deleting = false;
      },
      [DELETE_ERROR](state, error) {
        state.deleting = false;
        state.deleteError = error;
      }
    };

    const actions = {
      ...(deleteApi
        ? {
            async [camelCase(`delete_${module.name}`)]({ commit }, data) {
              commit(DELETE_INIT);
              try {
                await deleteApi(data);
                commit(DELETE_DONE);
              } catch (error) {
                commit(DELETE_ERROR, error);
                throw error;
              }
            }
          }
        : {})
    };

    return module.extend({ state, mutations, actions });
  };
}
